export enum PaymentPeriodEnum {
  CASH = 'CASH',

  ATDELIVERY = 'ATDELIVERY',

  DAILY = 'DAILY',

  WEEKLY = 'WEEKLY',

  BIMONTHLY = 'BIMONTHLY',

  MONTHLY = 'MONTHLY',

  VIREMENT = 'VIREMENT',
}
